






















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Cuenta from "@/models/cuenta";
import Tarjeta from "@/models/tarjeta";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { CuentaEstado } from "../../enums/Codes";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import NominaTransaccion from "../../models/tarjeta/nomina-transaccion.model";
import Transaccion from '../../models/tarjeta/transaccion.model';
import Nomina from '../../models/tarjeta/nomina.model';

@Component
export default class CuentaTableComponent extends GenericBTable<Cuenta> {
  @Prop() readonly cedula!: string;
  @Prop() readonly soloNominas!: boolean;
  @Prop() readonly soloTransacciones!: boolean;
  tableTarjetaConfig: BTableConfig<Tarjeta>;
  constructor() {
    super();
    this.tableTarjetaConfig = new BTableConfig<Tarjeta>();
    // this.tableTarjetaConfig.enableDefaultColumns = false;
  }
  filterTable: any = {};
  created() {
    if (this.cedula) {
      this.setupTarjetasTable();
      this.setupTable();
    }
  }
   onUpdateNominaTable(config: BTableConfig<Nomina>) {
    this.$emit('update:nominaTableConfig', config);
  }
   onUpdateTransaccionTable(config: BTableConfig<Transaccion>) {
    this.$emit('update:transaccionTableConfig', config);
  }
  get cuentaSelected() {
    return this.tableConfig.selection.selected;
  }
  setupTarjetasTable() {
    this.tableTarjetaConfig.controller = "Tarjeta";
    this.tableTarjetaConfig.activeActions = false;
    this.tableTarjetaConfig.pagination.perPage = 5;
    this.tableTarjetaConfig.pagination.perPage = 5;
    this.tableTarjetaConfig.loadOnMount = false;
    this.tableTarjetaConfig.detailed = true;
    let numero = new BTableColumn("numeroTarjeta", "Tarjeta");
    numero.customTemplate = true;
    this.tableTarjetaConfig.insertColumns(numero);
  }

  setupTable() {
    this.tableConfig.customButtomLeftTemplate = true;
    this.tableConfig.controller = "Cuenta";
    this.tableConfig.resource = `GetByCedula/${this.cedula}`;
    this.tableConfig.onLoad = (data: Cuenta[]) => {
      if (data && data.length) {
        this.tableConfig.resource = "";
        this.tableConfig.whereParams = this.getFiltros();
        this.tableConfig.include = "Beneficiario";
      }
    };
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.activeActions = false;
    this.tableConfig.selectable = true;
    this.tableConfig.pagination.perPage = 5;
    this.tableConfig.selection.change = (row: Cuenta, old: Cuenta) =>
      this.searchTarjeta(row.id as number, "");

    let numeroCuenta = new BTableColumn("numeroCuenta", "Cuenta");
    numeroCuenta.customTemplate = true;
    this.tableConfig.insertColumns(numeroCuenta);
  }
  cuentaFilterTitle = "Todas";
  tarjetaFilterTitle = "Todas";
  getFilterTitle(estado: string) {
    switch (estado) {
      case CuentaEstado.Activa:
        return "Activas";
      case CuentaEstado.Suspendida:
        return "Suspendidas";
      case CuentaEstado.Cancelada:
        return "Canceladas";
      default:
        return "Todas";
    }
  }

  getEstadoDesc(estado: string) {
    switch (estado) {
      case CuentaEstado.Activa:
        return "Activa";
      case CuentaEstado.Suspendida:
        return "Suspendida";
      case CuentaEstado.Cancelada:
        return "Cancelada";
      default:
        return "";
    }
  }

  getEstadoColor(estado: string) {
    switch (estado) {
      case CuentaEstado.Activa:
        return "has-text-success";
      case CuentaEstado.Suspendida:
        return "has-text-warning";
      case CuentaEstado.Cancelada:
        return "has-text-danger";
      default:
        return "";
    }
  }
  getTarjetaFiltros(id: number) {
    let result = [];
    result.push(`cuentaId==${id}`);
    if (this.filterTable.estado)
      result.push(`estado == "${this.filterTable.estado}"`);
    return result.join("&&");
  }
  getFiltros() {
    let result = [];
    result.push(`beneficiario.cedula=="${this.cedula}"`);
    if (this.filter.estado)
      result.push(`estadoCuenta == "${this.filter.estado}"`);
    return result.join("&&");
  }
  search(estado: string) {
    this.filter.estado = estado;
    this.cuentaFilterTitle = this.getFilterTitle(estado);
    this.tableConfig.whereParams = this.getFiltros();
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
  searchTarjeta(id: number, estado: string) {
    this.filterTable.estado = estado;
    this.tarjetaFilterTitle = this.getFilterTitle(estado);
    this.tableTarjetaConfig.whereParams = this.getTarjetaFiltros(id);
    if (this.tableTarjetaConfig.reload) this.tableTarjetaConfig.reload();
  }
}
